
const initTooltip = () => {
    const tooltip = document.getElementById('tooltip');
    const tooltipTriggers = document.querySelectorAll('.js-tooltip');
    let hideTooltipTimeout;

    tooltipTriggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
            const tooltipText = event.target.getAttribute('data-tooltip');
            tooltip.textContent = tooltipText;

            const rect = event.target.getBoundingClientRect();
            const tooltipWidth = tooltip.offsetWidth;
            const tooltipHeight = tooltip.offsetHeight;

            // Calculate position
            const top = rect.top + window.scrollY - tooltipHeight - 10; // 10px above the element
            const left = rect.left + window.scrollX + (rect.width / 2) - (tooltipWidth / 2);

            // Set tooltip position and display it
            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            tooltip.style.display = 'block';
        });

        trigger.addEventListener('mouseout', () => {
            hideTooltipTimeout = setTimeout(() => {
                tooltip.style.display = 'none';
            }, 2000); // Hide after 2 seconds
        });
    });
}

export {initTooltip}
